<template>
  <div>
    <nav class="bg-gray-800">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between h-16">
          <div class="flex">
            <div class="flex-shrink-0 flex items-center text-white">
              White Water Photography
            </div>
          </div>
          <!--                    <div v-if = "!user.id" class="flex items-center">-->
          <!--                        <div class="flex-shrink-0">-->
          <!--                            <router-link :to = "{name: 'login'}">-->
          <!--                                <base-button-primary>Log In</base-button-primary>-->
          <!--                            </router-link>-->
          <!--                        </div>-->
          <!--                    </div>-->
          <div v-if="user.role === 'admin'" class="flex items-center">
            <div class="flex-shrink-0">
              <router-link :to="{ name: 'admin' }">
                <base-button-primary>Admin</base-button-primary>
              </router-link>
            </div>
          </div>
          <div v-if="user.role === 'Outfitter'" class="flex items-center">
            <div class="flex-shrink-0">
              <router-link :to="{ name: 'dashboard' }">
                <base-button-primary>Dashboard</base-button-primary>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import BaseButtonPrimary from "../buttons/BaseButtonPrimary";
export default {
  name: "PublicNav",
  components: {
    BaseButtonPrimary,
  },
  methods: {},
  computed: {
    user: function () {
      return this.$store.getters["auth/getUser"];
    },
  },
};
</script>
